var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseScreen',_vm._b({},'BaseScreen',_vm.screen,false),[_c('Instruction',_vm._b({staticClass:"screen__stretch screen__offset-right"},'Instruction',_vm.instruction,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }